import { createContext, useContext, ReactNode } from "react"
import { User } from "@all-for-one/shared-types"

interface StudentContextType {
    studentId: string
    classId: string
}

export const StudentContext = createContext<StudentContextType | null>(null)

export const useStudentContext = () => {
    const context = useContext(StudentContext)
    if (!context) {
        throw new Error('useStudentContext must be used within a StudentContextProvider')
    }
    return context
}

interface StudentContextProviderProps {
    children: ReactNode
    initialStudent: User
    classId: string
}

export const StudentContextProvider = ({ children, initialStudent, classId }: StudentContextProviderProps) => {
    return (
        <StudentContext.Provider value={{
            studentId: initialStudent.userId,
            classId
        }}>
            { children }
        </StudentContext.Provider>
    )
}
